import { deleteObject, getBlob, listAll, ref, uploadBytes } from 'firebase/storage'
import { storage } from '../firebase'
import {
  type BackupFile, type Snapshot, backupName, prunableBackups, takenAtFrom,
} from './backup'

const dir = (uid: string) => ref(storage, `users/${uid}/backups`)

/** Newest first. */
export async function listBackups(uid: string): Promise<BackupFile[]> {
  const res = await listAll(dir(uid))
  return res.items
    .map((i) => ({ name: i.name, takenAt: takenAtFrom(i.name) }))
    .sort((a, b) => b.takenAt - a.takenAt)
}

/**
 * Writes a snapshot and prunes the oldest beyond the cap.
 *
 * The upload happens first: if pruning fails the account still gained a
 * backup, whereas pruning first could delete the oldest and then fail to
 * replace it.
 */
export async function writeBackup(uid: string, snap: Snapshot): Promise<string> {
  const name = backupName(snap.takenAt)
  const blob = new Blob([JSON.stringify(snap)], { type: 'application/json' })
  await uploadBytes(ref(dir(uid), name), blob, { contentType: 'application/json' })

  const stale = prunableBackups(await listBackups(uid))
  await Promise.all(stale.map((n) => deleteObject(ref(dir(uid), n)).catch(() => undefined)))
  return name
}

export async function readBackup(uid: string, name: string): Promise<Snapshot> {
  const blob = await getBlob(ref(dir(uid), name))
  return JSON.parse(await blob.text()) as Snapshot
}
